(function() {
	const CONFIG = Object.assign({
		collectionProductIds: [],
		preorderLiveVariants: [],
		shopLanguageRoot: '/',
		initialCoupons: [],
		initialBadges: {},
		initialColors: {},
		list: null,
		b2b: null,
		translations: {}
	}, window.CollectionFilterData || {});const B2B = CONFIG.b2b;function b2bFmt(n) { return (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
	function b2bPriceHtml(pid) {
		const key = String(pid);
		const groups = (B2B.productToGroups || {})[key] || [];
		const prices = B2B.prices || {};let cena = null;
		for(const g of groups) {
			const v = prices[String(g)];
			if(v === undefined || v === null || v === '') continue;const n = Number(v);
			if(!Number.isFinite(n)) continue;
			if(cena === null || n < cena) cena = n;
		}const aw = String(B2B.activeWindow || '');
		let vOkne = false;
		if(!aw || B2B.isStandard) vOkne = true;
		else if(B2B.standardWindowId && aw === String(B2B.standardWindowId)) vOkne = true;
		else vOkne = ((B2B.productWindows || {})[key] || []).some(w => String(w) === aw);const any = String(B2B.pricedAny || ',');
		const kdekoliv = groups.some(g => any.indexOf(',' + g + ',') !== -1);
		if(cena !== null && vOkne) return `<div class="product-price b2b-cardprice"><span>${b2bFmt(cena)}&nbsp;${esc(B2B.currency || '')}</span></div>`;
		if(kdekoliv && !vOkne) return `<div class="product-price b2b-cardnote">${esc(B2B.notInWindow || '')}</div>`;return `<div class="product-price b2b-cardnote b2b-cardask">${esc(B2B.onRequest || '')}</div>`;
	}

	const API_PROD = 'pages/api-filter';
	const API_EXTRA = 'pages/api-filter-additional-data';const CACHE_KEY = 'allProducts:' + (CONFIG.locale || 'x') + ':' + (CONFIG.market || 'x') + ':' + (CONFIG.userType || 'b2c');
	try { localStorage.removeItem('allProducts'); } catch(e) {}const TTL_MS = 60000;
	const SSR_CNT = 24;
	const BATCH_SZ = 24;
	const MAX_RET = 3;
	const TIMEOUT_MS = 15000;
	const DEBOUNCE_MS = 300;
	const FADE_OUT = 200;
	const FADE_STAGGER = 50;
	const T = CONFIG.translations || {};

	let prodMap = new Map();
	let colProds = [];
	let filteredProds = [];
	let coupons = Array.isArray(CONFIG.initialCoupons) ? CONFIG.initialCoupons : [];
	let badges = (CONFIG.initialBadges && typeof CONFIG.initialBadges === 'object') ? CONFIG.initialBadges : {};let colorLegend = (CONFIG.initialColors && typeof CONFIG.initialColors === 'object') ? CONFIG.initialColors : {};let valueLabels = (CONFIG.initialLabels && typeof CONFIG.initialLabels === 'object') ? CONFIG.initialLabels : {};const LBL_OVERRIDE = (CONFIG.labelOverride && typeof CONFIG.labelOverride === 'object') ? CONFIG.labelOverride : {};
	let isReady = false;
	let rendered = SSR_CNT;
	let filters = {};
	let hasFilters = false;
	let animToken = 0;
	let currentSort = 'manual';
	let isPaused = false;
	let pauseTimer = null;
	let handleMap = new Map();let deferApply = false;
	let drawerSnap = null;

	const grid = document.getElementById('test-product-grid');
	const trigger = document.getElementById('lazy-load-trigger');
	const fBar = document.getElementById('filter-bar');
	const drawer = document.getElementById('FilterDrawer');const COLL_ID = 'kolekce';
	let collSets = null;
	let collLabels = {};
	let collOrder = [];let collUnion = null;
	let collCurrent = null;
	let collTitle = null;
	let collByPid = null;const PRE_LIVE = new Set((CONFIG.preorderLiveVariants || []).map(String));

	function hasLivePreorder(p) {
		if(PRE_LIVE.size === 0 || !p || !p.var) return false;
		return p.var.some(v => v && v.i != null && PRE_LIVE.has(String(v.i)));
	}const fmtFallback = (amount, whole) => {
		if(typeof amount !== 'number' || !Number.isFinite(amount)) return '';
		try {
			const frac = (whole || Number.isInteger(amount)) ? 0 : 2;
			return new Intl.NumberFormat(CONFIG.locale || 'cs', {
				style: 'currency', currency: CONFIG.currency || 'CZK', minimumFractionDigits: frac, maximumFractionDigits: frac
			}).format(amount);
		} catch(e) { return amount + ' ' + (CONFIG.currency || 'CZK'); }
	};
	const fmtMoney = (amount) => (window.SkMoney ? window.SkMoney.format(amount) : fmtFallback(amount, false));const fmtMoneyWhole = (amount) => (window.SkMoney ? window.SkMoney.formatWhole(amount) : fmtFallback(amount, true));const cheapestVariant = (p) => {
		if(window.SkMoneyLib) return window.SkMoneyLib.cheapestVariant(p);
		if(!p || !Array.isArray(p.var)) return null;
		let best = null;
		for(const v of p.var) { if(v && typeof v.p === 'number' && Number.isFinite(v.p) && (best === null || v.p < best.p)) best = v; }
		return best;
	};

	function esc(str) {
		if(str == null) return '';
		return String(str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function debounce(fn, ms) {
		let timer = null;
		let lastArgs = null;
		const wrapped = function(...args) {
			lastArgs = args;
			if(timer) clearTimeout(timer);
			timer = setTimeout(() => {
				timer = null;
				fn.apply(null, lastArgs);
				lastArgs = null;
			}, ms);
		};
		wrapped.flush = function() {
			if(timer) {
				clearTimeout(timer);
				timer = null;
				if(lastArgs) fn.apply(null, lastArgs);
				lastArgs = null;
			}
		};
		return wrapped;
	}

	function parseSize(raw) {
		if(raw == null) return null;
		const str = String(raw).trim();
		if(str === '') return null;

		const matches = str.match(/\d+(?:[.,]\d+)?/g);
		if(!matches || matches.length === 0) {
			return { kind: 'text', label: str, key: normKey(str) };
		}

		const nums = matches.map(m => Number(String(m).replace(',', '.'))).filter(n => Number.isFinite(n));
		if(nums.length === 0) {
			return { kind: 'text', label: str, key: normKey(str) };
		}

		if(nums.length === 1) {
			return { kind: 'numeric', min: nums[0], max: nums[0], label: str };
		}

		const a = nums[0], b = nums[1];
		const lo = Math.min(a, b), hi = Math.max(a, b);
		return { kind: 'numeric', min: lo, max: hi, label: str };
	}

	function normKey(str) {
		return String(str).trim().toLowerCase().replace(/\s+/g, ' ');
	}

	function overlaps(a, b) {
		return a.min <= b.max && b.min <= a.max;
	}

	function getConfigs() {const els = [];
		if(fBar) els.push(...fBar.querySelectorAll('[data-filter-wrap]'));
		if(drawer) els.push(...drawer.querySelectorAll('[data-filter-wrap]'));
		return els.map(el => ({
			el,
			id: el.getAttribute('data-filter-id'),
			type: el.getAttribute('data-filter-type'),
			srcVal: el.getAttribute('data-filter-source-value'),
			srcKey: el.getAttribute('data-filter-source-key'),
			name: el.getAttribute('data-filter-name'),
			key: el.getAttribute('data-filter-id') || (el.getAttribute('data-filter-source-value') + '::' + el.getAttribute('data-filter-source-key'))
		}));
	}

	function capFirst(str) {
		if(str == null) return '';
		const s = String(str);
		if(s.length === 0) return s;
		return s.charAt(0).toLocaleUpperCase('cs') + s.slice(1);
	}function dostupnostAktivni() {
		for(const cfg of getConfigs()) {
			if(cfg.srcVal !== 'availability') continue;
			const a = filters[cfg.key];
			if(a instanceof Set && a.size > 0) return a;
		}
		return null;
	}function variantaVyhovuje(v, volba) {
		if(!volba) return true;
		const skladem = volba.has('in_stock') || (!volba.has('in_stock') && !volba.has('preorder'));
		if(skladem && v && typeof v.q === 'number' && v.q > 0) return true;
		if(volba.has('preorder') && v && v.i != null && PRE_LIVE.has(String(v.i))) return true;
		return false;
	}function velikostiProduktu(p, srcVal, srcKey, volba) {
		if(srcVal !== 'option' || !p || !p.var) return toStrArr(getVal(p, srcVal, srcKey));
		const out = new Set();
		for(const v of p.var) {
			if(!v || v[srcKey] == null) continue;
			if(!variantaVyhovuje(v, volba)) continue;
			out.add(String(v[srcKey]));
		}
		return Array.from(out);
	}const SIZE_WORDS = ['velikost', 'veľkos', 'velkos', 'size', 'größe', 'grösse', 'groesse', 'méret', 'meret', 'rozmiar'];
	function isSize(cfg) {
		const k = normKey((cfg.srcKey || '') + ' ' + (cfg.name || ''));
		return SIZE_WORDS.some(w => k.includes(w));
	}

	function getVal(p, srcVal, srcKey) {
		if(!p) return null;
		switch(srcVal) {
			case 'price':
				{ const cv = cheapestVariant(p); return cv ? cv.p : null; }
			case 'availability':
				if(!p.var) return false;
				return p.var.some(v => v && typeof v.q === 'number' && v.q > 0);
			case 'option': {
				if(!p.var) return null;
				const vals = new Set();
				for(const v of p.var) {
					if(v && v[srcKey] != null) vals.add(v[srcKey]);
				}
				return vals.size > 0 ? Array.from(vals) : null;
			}
			case 'metafield':
				if(!p.mf) return null;
				return p.mf[srcKey] != null ? p.mf[srcKey] : null;
			case 'collection':return collByPid ? (collByPid.get(p.pid) || null) : null;
			default:
				return null;
		}
	}

	function toStrArr(v) {
		if(v == null) return [];
		if(Array.isArray(v)) return v.filter(x => x != null).map(x => String(x));
		return [String(v)];
	}function aggCheck(prods, cfg, dropFull) {
		const srcVal = cfg.srcVal;
		const srcKey = cfg.srcKey;

		if(srcVal === 'availability') {
			let stockCnt = 0, preCnt = 0;
			for(const p of prods) {
				if(getVal(p, srcVal, srcKey) === true) stockCnt++;
				if(hasLivePreorder(p)) preCnt++;
			}const act = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
			const out = [];
			if(stockCnt > 0 || act.has('in_stock')) out.push({ key: 'in_stock', label: T.inStock || 'Skladem', count: stockCnt, section: null });
			if(preCnt > 0 || act.has('preorder')) out.push({ key: 'preorder', label: T.preorder || 'Na předobjednávku', count: preCnt, section: null });
			return out;
		}

		if(srcVal === 'collection') {if(!collByPid) return [];
			let cOut = collOrder.map(h => {
				let cnt = 0;
				for(const p of prods) {
					const hs = collByPid.get(p.pid);
					if(hs && hs.indexOf(h) !== -1) cnt++;
				}
				return { key: h, label: collLabels[h] || h, count: cnt, section: null };
			});
			if(dropFull) {
				const act = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
				cOut = cOut.filter(o => o.count < prods.length || act.has(o.key));
			}
			return cOut;
		}

		const buckets = new Map();
		for(const p of prods) {
			const raw = getVal(p, srcVal, srcKey);const seen = new Set();
			for(const v of toStrArr(raw)) {
				const k = normKey(v);
				if(seen.has(k)) continue;
				seen.add(k);
				if(!buckets.has(k)) {
					buckets.set(k, { key: k, lblCounts: new Map(), total: 0 });
				}
				const b = buckets.get(k);
				b.lblCounts.set(v, (b.lblCounts.get(v) || 0) + 1);
				b.total++;
			}
		}

		let out = Array.from(buckets.values())
			.map(b => ({ key: b.key, label: popisekHodnoty(cfg, b.key, capFirst(mostCommon(b.lblCounts))), count: b.total, section: null }));
		if(dropFull) {
			const act = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
			out = out.filter(o => o.count < prods.length || act.has(o.key));
		}
		return out.sort(lblSort);
	}function popisekHodnoty(cfg, key, fallback) {
		if(LBL_OVERRIDE && typeof LBL_OVERRIDE === 'object' && LBL_OVERRIDE[key]) return LBL_OVERRIDE[key];
		const mapa = cfg && cfg.srcKey ? valueLabels[cfg.srcKey] : null;
		if(mapa) {
			for(const [hodnota, popis] of Object.entries(mapa)) {
				if(normKey(hodnota) === key) return popis;
			}
		}
		return fallback;
	}

	function mostCommon(counts) {
		let best = null;
		let bestCnt = -1;
		for(const [lbl, cnt] of counts.entries()) {
			if(cnt > bestCnt) { best = lbl; bestCnt = cnt; }
		}
		return best;
	}

	function lblSort(a, b) {
		const an = Number(a.label), bn = Number(b.label);
		if(Number.isFinite(an) && Number.isFinite(bn)) return an - bn;
		return String(a.label).localeCompare(String(b.label), 'cs');
	}

	function aggSizes(prods, srcVal, srcKey) {
		const numBuckets = new Map();
		const txtBuckets = new Map();const volba = dostupnostAktivni();
		for(const p of prods) {
			for(const v of velikostiProduktu(p, srcVal, srcKey, volba)) {
				const parsed = parseSize(v);
				if(!parsed) continue;
				if(parsed.kind === 'numeric') {
					if(parsed.min === parsed.max) {
						if(!numBuckets.has(parsed.min)) numBuckets.set(parsed.min, { val: parsed.min, label: String(parsed.min) });
					} else {
						for(let val = parsed.min; val <= parsed.max; val++) {
							if(!numBuckets.has(val)) numBuckets.set(val, { val, label: String(val) });
						}
					}
				} else {
					if(!txtBuckets.has(parsed.key)) {
						txtBuckets.set(parsed.key, { label: capFirst(parsed.label) });
					}
				}
			}
		}

		const numEntries = Array.from(numBuckets.values()).sort((a,b) => a.val - b.val);
		const txtEntries = Array.from(txtBuckets.entries());

		const numList = numEntries.map(b => {
			let cnt = 0;
			const testInterval = { min: b.val, max: b.val };
			for(const p of prods) {
				const raw = getVal(p, srcVal, srcKey);
				let matched = false;
				for(const v of toStrArr(raw)) {
					const parsed = parseSize(v);
					if(parsed && parsed.kind === 'numeric' && overlaps(parsed, testInterval)) {
						matched = true; break;
					}
				}
				if(matched) cnt++;
			}
			return { key: 'num|' + b.val + '|' + b.val, label: b.label, count: cnt, section: null };
		});

		const txtList = txtEntries.map(([k, b]) => {
			let cnt = 0;
			for(const p of prods) {
				const raw = getVal(p, srcVal, srcKey);
				let matched = false;
				for(const v of toStrArr(raw)) {
					const parsed = parseSize(v);
					if(parsed && parsed.kind === 'text' && parsed.key === k) {
						matched = true; break;
					}
				}
				if(matched) cnt++;
			}
			return { key: 'txt|' + k, label: b.label, count: cnt, section: 'other' };
		}).sort(lblSort);

		return numList.concat(txtList);
	}

	function aggSlider(prods, cfg) {
		let min = Infinity, max = -Infinity;
		for(const p of prods) {
			const v = getVal(p, cfg.srcVal, cfg.srcKey);
			if(Number.isFinite(v)) {
				if(v < min) min = v;
				if(v > max) max = v;
			}
		}
		if(!Number.isFinite(min)) return null;
		return { min: Math.floor(min), max: Math.ceil(max) };
	}

	function matchesFilter(p, cfg, active) {
		if(cfg.type === 'slider') {
			const val = getVal(p, cfg.srcVal, cfg.srcKey);
			if(!Number.isFinite(val)) return false;
			if(active.min != null && val < active.min) return false;
			if(active.max != null && val > active.max) return false;
			return true;
		}

		if(!(active instanceof Set) || active.size === 0) return true;

		if(cfg.srcVal === 'availability') {if(active.has('in_stock') && getVal(p, cfg.srcVal, cfg.srcKey) === true) return true;
			if(active.has('preorder') && hasLivePreorder(p)) return true;if(!active.has('in_stock') && !active.has('preorder')) return getVal(p, cfg.srcVal, cfg.srcKey) === true;
			return false;
		}

		if(isSize(cfg)) {
			return matchesSize(p, cfg, active);
		}

		const raw = getVal(p, cfg.srcVal, cfg.srcKey);
		if(raw == null) return false;
		for(const v of toStrArr(raw)) {
			if(active.has(normKey(v))) return true;
		}
		return false;
	}

	function matchesSize(p, cfg, active) {
		const hodnoty = velikostiProduktu(p, cfg.srcVal, cfg.srcKey, dostupnostAktivni());
		if(hodnoty.length === 0) return false;

		const selIntervals = [];
		const selTexts = new Set();
		for(const k of active) {
			if(k.startsWith('num|')) {
				const parts = k.split('|');
				const lo = Number(parts[1]);
				const hi = Number(parts[2]);
				if(Number.isFinite(lo) && Number.isFinite(hi)) {
					selIntervals.push({ min: lo, max: hi });
				}
			} else if(k.startsWith('txt|')) {
				selTexts.add(k.slice(4));
			} else {const parsedKey = parseSize(k);
				if(parsedKey && parsedKey.kind === 'numeric') selIntervals.push({ min: parsedKey.min, max: parsedKey.max });
				else if(parsedKey) selTexts.add(parsedKey.key);
			}
		}

		for(const v of hodnoty) {
			const parsed = parseSize(v);
			if(!parsed) continue;
			if(parsed.kind === 'numeric') {
				for(const sel of selIntervals) {
					if(overlaps(parsed, sel)) return true;
				}
			} else {
				if(selTexts.has(parsed.key)) return true;
			}
		}
		return false;
	}

	function sortProducts(prods) {
		const arr = [...prods];const priceOr = (p, dflt) => { const v = getVal(p, 'price', null); return Number.isFinite(v) ? v : dflt; };
		if(currentSort === 'price-asc') {
			arr.sort((a, b) => priceOr(a, Infinity) - priceOr(b, Infinity) || 0);
		} else if(currentSort === 'price-desc') {
			arr.sort((a, b) => priceOr(b, -Infinity) - priceOr(a, -Infinity) || 0);
		} else if(currentSort === 'title-asc') {
			arr.sort((a, b) => String(a.tit).localeCompare(String(b.tit), 'cs'));
		} else {
			arr.sort((a, b) => a._idx - b._idx);
		}
		return arr;
	}

	function applyFilters() {
		if(!hasFilters) {
			filteredProds = colProds.slice();
		} else {
			const cfgs = getConfigs();
			filteredProds = colProds.filter(p => {
				for(const cfg of cfgs) {
					const active = filters[cfg.key];
					if(!active) continue;
					if(active instanceof Set && active.size === 0) continue;
					if(!matchesFilter(p, cfg, active)) return false;
				}
				return true;
			});
		}
		
		filteredProds = sortProducts(filteredProds);
		updateCountText();
		updateDynamicCounts();
	}

	function updateCountText() {
		const countEl = document.querySelector('[data-collection-count]');
		if(!countEl) return;
		const cnt = filteredProds.length;
		let text = '';
		if(cnt === 0) text = T.count0 || '0 položek';
		else if(cnt === 1) text = T.count1 || '1 položka';
		else if(cnt >= 2 && cnt <= 4) text = (T.count24 || '{count} položky').replace('{count}', cnt);
		else text = (T.countMany || '{count} položek').replace('{count}', cnt);
		countEl.textContent = text;
	}

	function updateDynamicCounts() {
		if(!fBar) return;
		const cfgs = getConfigs();

		for(const cfg of cfgs) {
			if(cfg.type === 'slider') continue;

			const otherProds = colProds.filter(p => {
				for(const otherCfg of cfgs) {
					if(otherCfg.key === cfg.key) continue;
					const active = filters[otherCfg.key];
					if(!active) continue;
					if(active instanceof Set && active.size === 0) continue;
					if(!matchesFilter(p, otherCfg, active)) return false;
				}
				return true;
			});

			let newOpts = [];
			if(isSize(cfg)) newOpts = aggSizes(otherProds, cfg.srcVal, cfg.srcKey);
			else newOpts = aggCheck(otherProds, cfg);

			const countMap = new Map();
			for(const opt of newOpts) countMap.set(opt.key, opt.count);

			if(isSize(cfg)) {
				const btns = cfg.el.querySelectorAll('.filter-size-btn');
				btns.forEach(btn => {
					const val = btn.getAttribute('data-filter-value');
					const count = countMap.get(val) || 0;
					if(count === 0 && !(filters[cfg.key] instanceof Set && filters[cfg.key].has(val))) {
						btn.classList.add('disabled');
					} else {
						btn.classList.remove('disabled');
					}
				});
			} else {
				const rows = cfg.el.querySelectorAll('.filter-checkbox-row');
				rows.forEach(row => {
					const input = row.querySelector('input');
					const val = input.getAttribute('data-filter-value');
					const countEl = row.querySelector('.count');
					const count = countMap.get(val) || 0;
					
					if(countEl) countEl.textContent = count;
					
					if(count === 0 && !(filters[cfg.key] instanceof Set && filters[cfg.key].has(val))) {
						row.style.opacity = '0.4';
						row.style.pointerEvents = 'none';
					} else {
						row.style.opacity = '1';
						row.style.pointerEvents = 'auto';
					}
				});
			}
		}
	}function sbUpdate(pop) {
		const scroll = pop.querySelector('.filter-pop-scroll');
		const track = pop.querySelector('.filter-sb-track');
		const thumb = pop.querySelector('.filter-sb-thumb');
		if(!scroll || !track || !thumb) return;
		const sh = scroll.scrollHeight, ch = scroll.clientHeight;
		if(sh <= ch + 1) { pop.classList.remove('has-scroll'); pop.classList.remove('sb-top'); pop.classList.remove('sb-bot'); return; }
		pop.classList.add('has-scroll');
		pop.classList.toggle('sb-top', scroll.scrollTop > 2);
		pop.classList.toggle('sb-bot', scroll.scrollTop < sh - ch - 2);
		const th = track.clientHeight;
		if(th < 30) return;
		const h = Math.max(24, Math.round(ch / sh * th));
		const maxTop = th - h;
		const top = Math.round(scroll.scrollTop / (sh - ch) * maxTop);
		thumb.style.height = h + 'px';
		thumb.style.transform = 'translateY(' + Math.min(maxTop, Math.max(0, top)) + 'px)';
	}

	function sbInitAll() {
		const pops = [];
		if(fBar) pops.push(...fBar.querySelectorAll('.filter-popover'));
		if(drawer) pops.push(...drawer.querySelectorAll('.fd-scrollwrap'));
		pops.forEach(pop => {
			if(pop._sb) { sbUpdate(pop); return; }
			const scroll = pop.querySelector('.filter-pop-scroll');
			const track = pop.querySelector('.filter-sb-track');
			const thumb = pop.querySelector('.filter-sb-thumb');
			if(!scroll || !track || !thumb) return;
			pop._sb = true;
			scroll.addEventListener('scroll', () => sbUpdate(pop), {passive: true});
			thumb.addEventListener('pointerdown', (e) => {
				e.preventDefault();
				e.stopPropagation();
				thumb.classList.add('dragging');
				thumb.setPointerCapture(e.pointerId);
				const startY = e.clientY, startTop = scroll.scrollTop;
				const onMove = (ev) => {
					const th = track.clientHeight, sh = scroll.scrollHeight, ch = scroll.clientHeight;
					const hh = Math.max(24, Math.round(ch / sh * th));
					const ratio = (sh - ch) / Math.max(1, th - hh);
					scroll.scrollTop = startTop + (ev.clientY - startY) * ratio;
				};
				const onUp = () => {
					thumb.classList.remove('dragging');
					thumb.removeEventListener('pointermove', onMove);
					thumb.removeEventListener('pointerup', onUp);
				};
				thumb.addEventListener('pointermove', onMove);
				thumb.addEventListener('pointerup', onUp);
			});
			sbUpdate(pop);
		});
	}

	function renderPopovers() {
		if(!fBar) return;
		const cfgs = getConfigs();
		for(const cfg of cfgs) {
			const popover = cfg.el.querySelector('[data-filter-popover]');
			if(!popover) continue;

			if(cfg.type === 'slider') {
				const range = aggSlider(colProds, cfg);
				cfg.el.style.display = range ? '' : 'none';
				if(!range) continue;
				popover.innerHTML = buildSliderUI(cfg, range);
				bindSlider(cfg, popover, range);
			} else if(cfg.type === 'color') {
				const opts = aggColor(colProds, cfg);
				cfg.el.style.display = (opts && opts.length > 0) ? '' : 'none';
				if(!opts || opts.length === 0) continue;
				popover.innerHTML = buildColorUI(cfg, opts);
				bindCheck(cfg, popover);
			} else if(isSize(cfg)) {
				const opts = aggSizes(colProds, cfg.srcVal, cfg.srcKey);
				cfg.el.style.display = (opts && opts.length > 0) ? '' : 'none';
				if(!opts || opts.length === 0) continue;
				popover.innerHTML = buildSizeUI(cfg, opts);
				bindSizeUI(cfg, popover);
			} else {const opts = aggCheck(colProds, cfg, true);
				cfg.el.style.display = (opts && opts.length > 0) ? '' : 'none';
				if(!opts || opts.length === 0) continue;
				popover.innerHTML = buildCheckUI(cfg, opts);
				bindCheck(cfg, popover);
			}
		}
		updateBarState();
		sbInitAll();
	}

	function buildSizeUI(cfg, opts) {
		const active = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
		let html = '<div class="filter-size-grid">';
		for(const opt of opts) {
			const isActive = active.has(opt.key) ? 'active' : '';
			const isDis = opt.count === 0 ? 'disabled' : '';
			html += `<button type="button" class="filter-size-btn ${isActive} ${isDis}" data-filter-value="${esc(opt.key)}">${esc(opt.label)}</button>`;
		}
		html += '</div>';
		return html;
	}

	function bindSizeUI(cfg, popover) {
		popover.querySelectorAll('.filter-size-btn').forEach(btn => {
			btn.addEventListener('click', () => {
				if(btn.classList.contains('disabled')) return;
				const val = btn.getAttribute('data-filter-value');
				if(!(filters[cfg.key] instanceof Set)) filters[cfg.key] = new Set();
				
				if(filters[cfg.key].has(val)) {
					filters[cfg.key].delete(val);
					btn.classList.remove('active');
				} else {
					filters[cfg.key].add(val);
					btn.classList.add('active');
				}
				if(filters[cfg.key].size === 0) delete filters[cfg.key];
				
				checkFiltersActive();
				updateBarState();
				queueApply();
			});
		});
	}

	function buildCheckUI(cfg, opts) {
		const active = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
		let html = '';
		let lastSec = undefined;
		for(const opt of opts) {
			if(opt.section !== lastSec) {
				lastSec = opt.section;
				if(opt.section === 'other') {
					html += `<div class="filter-section-divider">${esc(T.otherSection || 'Ostatní')}</div>`;
				}
			}
			const checked = active.has(opt.key) ? 'checked' : '';
			html += `
				<label class="filter-checkbox-row">
					<input type="checkbox" data-filter-value="${esc(opt.key)}" ${checked}>
					<div class="filter-cb-box"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg></div>
					<span>${esc(opt.label)}</span>
					<span class="count">${opt.count}</span>
				</label>
			`;
		}
		return html;
	}

	function bindCheck(cfg, popover) {if(popover._checkBound) return;
		popover._checkBound = true;
		popover.addEventListener('change', (e) => {
			const input = e.target.closest('input[type="checkbox"]');
			if(!input) return;
			const val = input.getAttribute('data-filter-value');
			if(!(filters[cfg.key] instanceof Set)) filters[cfg.key] = new Set();
			if(input.checked) filters[cfg.key].add(val);
			else filters[cfg.key].delete(val);
			if(filters[cfg.key].size === 0) delete filters[cfg.key];
			checkFiltersActive();
			updateBarState();
			queueApply();
		});
	}function aggColor(prods, cfg) {
		const counts = new Map();
		for(const p of prods) {
			const raw = getVal(p, cfg.srcVal, cfg.srcKey);
			if(raw == null) continue;
			const seen = new Set();
			for(const v of toStrArr(raw)) {
				const k = normKey(v);
				if(seen.has(k)) continue;
				seen.add(k);
				counts.set(k, (counts.get(k) || 0) + 1);
			}
		}
		const active = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
		const opts = [];
		for(const key of Object.keys(colorLegend)) {
			const cnt = counts.get(key) || 0;
			if((cnt > 0 && cnt < prods.length) || active.has(key)) opts.push({key, label: colorLegend[key].label || capFirst(key), hex: colorLegend[key].hex || [], count: cnt});
			counts.delete(key);
		}
		for(const [key, cnt] of counts) opts.push({key, label: capFirst(key), hex: [], count: cnt});
		return opts;
	}

	function colorSwatchCss(hexes) {
		if(!hexes || hexes.length === 0) return 'background: #d8d8d8;';
		if(hexes.length === 1) return `background: ${esc(hexes[0])};`;if(hexes.length === 2) return `background: linear-gradient(135deg, ${esc(hexes[0])} 0%, ${esc(hexes[0])} 35%, ${esc(hexes[1])} 65%, ${esc(hexes[1])} 100%);`;const step = 360 / hexes.length;
		const stops = hexes.map((h, i) => `${esc(h)} ${Math.round(i * step)}deg`).concat(`${esc(hexes[0])} 360deg`).join(', ');
		return `background: conic-gradient(${stops});`;
	}

	function buildColorUI(cfg, opts) {
		const active = filters[cfg.key] instanceof Set ? filters[cfg.key] : new Set();
		let html = '';
		for(const opt of opts) {
			const checked = active.has(opt.key) ? 'checked' : '';
			html += `
				<label class="filter-checkbox-row filter-color-row">
					<input type="checkbox" data-filter-value="${esc(opt.key)}" ${checked}>
					<span class="filter-color-dot" style="${colorSwatchCss(opt.hex)}"></span>
					<span>${esc(opt.label)}</span>
					<span class="count">${opt.count}</span>
				</label>
			`;
		}
		return html;
	}

	function buildSliderUI(cfg, range) {
		const cur = filters[cfg.key] || { min: range.min, max: range.max };
		const cMin = Math.max(range.min, Number.isFinite(cur.min) ? cur.min : range.min);
		const cMax = Math.min(range.max, Number.isFinite(cur.max) ? cur.max : range.max);
		return `
			<div class="filter-slider-wrap">
				<div class="filter-slider-labels">
					<span data-min-label>${esc(fmtMoneyWhole(cMin))}</span>
					<span data-max-label>${esc(fmtMoneyWhole(cMax))}</span>
				</div>
				<div class="filter-slider-track">
					<div class="filter-slider-range" data-range-fill></div>
					<input type="range" min="${range.min}" max="${range.max}" value="${cMin}" step="1" data-min-input>
					<input type="range" min="${range.min}" max="${range.max}" value="${cMax}" step="1" data-max-input>
				</div>
			</div>
		`;
	}

	function bindSlider(cfg, popover, range) {
		const minInput = popover.querySelector('[data-min-input]');
		const maxInput = popover.querySelector('[data-max-input]');
		const minLbl = popover.querySelector('[data-min-label]');
		const maxLbl = popover.querySelector('[data-max-label]');
		const fill = popover.querySelector('[data-range-fill]');

		function updateVis() {
			const min = Number(minInput.value);
			const max = Number(maxInput.value);
			minLbl.textContent = fmtMoneyWhole(min);
			maxLbl.textContent = fmtMoneyWhole(max);
			const span = range.max - range.min || 1;
			const pctMin = ((min - range.min) / span) * 100;
			const pctMax = ((max - range.min) / span) * 100;
			fill.style.left = pctMin + '%';
			fill.style.width = (pctMax - pctMin) + '%';
		}

		function order() {
			let min = Number(minInput.value);
			let max = Number(maxInput.value);
			if(min > max) {
				const tmp = min; min = max; max = tmp;
				minInput.value = min;
				maxInput.value = max;
			}
		}

		function commit() {
			order();
			const min = Number(minInput.value);
			const max = Number(maxInput.value);
			if(min === range.min && max === range.max) {
				delete filters[cfg.key];
			} else {
				filters[cfg.key] = { min, max };
			}
			checkFiltersActive();
			updateBarState();
			queueApply();
		}let cenaTimer = null;
		const commitPoKlidu = () => {
			clearTimeout(cenaTimer);
			cenaTimer = setTimeout(() => { cenaTimer = null; commit(); }, 250);
		};

		updateVis();
		[minInput, maxInput].forEach(inp => {
			inp.addEventListener('input', () => { order(); updateVis(); commitPoKlidu(); });
			inp.addEventListener('change', () => { clearTimeout(cenaTimer); cenaTimer = null; commit(); });
		});
	}

	function checkFiltersActive() {
		hasFilters = false;
		for(const k of Object.keys(filters)) {
			const v = filters[k];
			if(v instanceof Set) {
				if(v.size > 0) { hasFilters = true; break; }
			} else if(v && (v.min != null || v.max != null)) {
				hasFilters = true; break;
			}
		}
	}

	function updateBarState() {
		if(!fBar) return;
		for(const cfg of getConfigs()) {
			const btn = cfg.el.querySelector('[data-filter-toggle]');
			const cntEl = cfg.el.querySelector('[data-filter-count]');
			const active = filters[cfg.key];
			let count = 0;
			if(active instanceof Set) count = active.size;
			else if(active && (active.min != null || active.max != null)) count = 1;

			if(count > 0) {
				btn.classList.add('active');
				cntEl.textContent = String(count);
				cntEl.style.display = 'inline-flex';
			} else {
				btn.classList.remove('active');
				cntEl.style.display = 'none';
			}
		}
		const clearBtn = fBar.querySelector('[data-filter-clear-all]');
		if(clearBtn) clearBtn.hidden = !hasFilters;if(collSets) {
			const act = filters[COLL_ID];
			document.querySelectorAll('[data-ch-filter-collection]').forEach(card => {
				const on = act instanceof Set && act.has(card.getAttribute('data-ch-filter-collection'));
				card.classList.toggle('is-active', on);
			});
			updateCollTitle();
		}const dTrig = document.getElementById('FilterDrawerTrigger');
		if(dTrig) {
			let total = 0;
			for(const k of Object.keys(filters)) {
				const v = filters[k];
				if(v instanceof Set) total += v.size;
				else if(v && (v.min != null || v.max != null)) total += 1;
			}
			const badge = dTrig.querySelector('[data-filter-count]');
			if(badge) {
				badge.textContent = String(total);
				badge.style.display = total > 0 ? 'inline-flex' : 'none';
			}
		}
	}function updateCollTitle() {
		if(!collTitle) return;
		const el = document.querySelector('[data-ch-title-suffix]');
		if(!el) return;
		const act = filters[COLL_ID];
		const loc = CONFIG.locale || 'cs';
		const names = act instanceof Set ? collOrder.filter(h => act.has(h)).map((h, i) => {
			const l = String(collLabels[h] || h);
			if(i === 0) return l.charAt(0).toLocaleUpperCase(loc) + l.slice(1);
			return collTitle.lower ? l.charAt(0).toLocaleLowerCase(loc) + l.slice(1) : l;
		}) : [];
		let txt = '';
		if(names.length === 1) txt = names[0];
		else if(names.length > 1) txt = names.slice(0, -1).join(', ') + ' ' + (collTitle.joiner || '&') + ' ' + names[names.length - 1];
		el.textContent = txt ? ': ' + txt : '';
	}function presetCurrentCollection() {
		if(!collCurrent) return false;
		if(filters[COLL_ID] instanceof Set && filters[COLL_ID].size > 0) return false;
		filters[COLL_ID] = new Set([collCurrent]);
		checkFiltersActive();
		return true;
	}function onlyPreset() {
		if(!collCurrent || (currentSort && currentSort !== 'manual')) return false;
		const keys = Object.keys(filters).filter(k => {
			const v = filters[k];
			return v instanceof Set ? v.size > 0 : (v && (v.min != null || v.max != null));
		});
		return keys.length === 1 && keys[0] === COLL_ID && filters[COLL_ID].size === 1 && filters[COLL_ID].has(collCurrent);
	}

	function adoptCollectionFilter() {
		const holder = document.querySelector('[data-ch-collection-filter]');
		if(!holder || !fBar) return;
		let data = null;
		try { data = JSON.parse(holder.querySelector('[data-ch-collection-sets]').textContent); } catch(e) {}
		if(!data || !data.sets) { holder.remove(); return; }
		const order = (Array.isArray(data.order) ? data.order : Object.keys(data.sets))
			.filter(h => Array.isArray(data.sets[h]) && data.sets[h].length > 0);
		if(order.length === 0) { holder.remove(); return; }
		collOrder = order;
		collLabels = data.labels || {};
		collSets = new Map();
		collByPid = new Map();
		for(const h of collOrder) {
			const ids = data.sets[h].map(Number);
			collSets.set(h, new Set(ids));
			for(const id of ids) {
				if(!collByPid.has(id)) collByPid.set(id, []);
				const hs = collByPid.get(id);
				if(hs.indexOf(h) === -1) hs.push(h);
			}
		}
		collCurrent = (typeof data.current === 'string' && collSets.has(data.current)) ? data.current : null;
		collTitle = (data.title && data.title.mode === 'collections') ? data.title : null;
		if(data.scope === 'cards') {const seen = new Set();
			collUnion = [];
			for(const id of (CONFIG.collectionProductIds || [])) { const n = Number(id); if(!seen.has(n)) { seen.add(n); collUnion.push(n); } }
			for(const h of collOrder) for(const n of collSets.get(h)) { if(!seen.has(n)) { seen.add(n); collUnion.push(n); } }
		}
		const pill = holder.querySelector('.filter-btn-wrap[data-filter-wrap]');
		const group = holder.querySelector('.fd-group[data-filter-wrap]');
		if(pill) {
			const firstWrap = fBar.querySelector('[data-filter-wrap]');
			if(firstWrap) fBar.insertBefore(pill, firstWrap);
			else fBar.appendChild(pill);
		}
		if(group && drawer) {
			const groups = drawer.querySelector('.fd-groups');
			if(groups) groups.insertBefore(group, groups.firstChild);
		}
		holder.remove();
		document.querySelectorAll('[data-ch-filter-collection]').forEach(card => {
			card.addEventListener('click', (e) => {
				e.preventDefault();
				const h = card.getAttribute('data-ch-filter-collection');
				if(!(filters[COLL_ID] instanceof Set)) filters[COLL_ID] = new Set();
				if(filters[COLL_ID].has(h)) filters[COLL_ID].delete(h);
				else filters[COLL_ID].add(h);
				if(filters[COLL_ID].size === 0) delete filters[COLL_ID];
				checkFiltersActive();
				renderPopovers();
				updateDynamicCounts();if(isReady) queueApply();
			});
		});
	}

	function bindBar() {
		if(!fBar) return;

		fBar.addEventListener('click', (e) => {
			const sortWrap = document.getElementById('CustomSortWrap');
			const sortLabel = document.getElementById('CustomSortLabel');

			const sortOpt = e.target.closest('.sort-option');
			if(sortOpt) {
				sortWrap.querySelectorAll('.sort-option').forEach(o => o.classList.remove('active'));
				sortOpt.classList.add('active');
				sortLabel.textContent = sortOpt.textContent;
				sortWrap.classList.remove('is-open');
				currentSort = sortOpt.getAttribute('data-val');
				applyFilters();
				stavDoUrl();
				animGrid();
				return;
			}

			if(e.target.closest('#CustomSortTrigger')) {
				const isOpen = sortWrap.classList.contains('is-open');
				fBar.querySelectorAll('[data-filter-wrap]').forEach(w => w.classList.remove('is-open'));
				sortWrap.classList.toggle('is-open', !isOpen);
				return;
			}

			const toggle = e.target.closest('[data-filter-toggle]');
			if(toggle) {
				const wrap = toggle.closest('[data-filter-wrap]');
				const isOpen = wrap.classList.contains('is-open');
				
				fBar.querySelectorAll('[data-filter-wrap]').forEach(w => w.classList.remove('is-open'));
				if(sortWrap) sortWrap.classList.remove('is-open');
				
				if(!isOpen) { wrap.classList.add('is-open'); requestAnimationFrame(sbInitAll); }
				return;
			}

			if(e.target.closest('[data-filter-clear-all]')) {
				filters = {};
				hasFilters = false;
				renderPopovers();
				queueApply();
			}
		});function closeAllPopovers() {
			fBar.querySelectorAll('[data-filter-wrap].is-open').forEach(w => w.classList.remove('is-open'));
			const sw = document.getElementById('CustomSortWrap');
			if(sw) sw.classList.remove('is-open');
		}
		document.addEventListener('click', (e) => {
			if(e.target.closest('#filter-bar [data-filter-wrap], #CustomSortWrap')) return;
			closeAllPopovers();
		});
		document.addEventListener('keydown', (e) => {
			if(e.key === 'Escape') closeAllPopovers();
		});function syncAriaExpanded() {
			fBar.querySelectorAll('[data-filter-wrap]').forEach(w => {
				const b = w.querySelector('[data-filter-toggle]');
				if(b) b.setAttribute('aria-expanded', w.classList.contains('is-open') ? 'true' : 'false');
			});
			const sw = document.getElementById('CustomSortWrap');
			const st = document.getElementById('CustomSortTrigger');
			if(sw && st) st.setAttribute('aria-expanded', sw.classList.contains('is-open') ? 'true' : 'false');
		}
		fBar.addEventListener('click', syncAriaExpanded);

		document.addEventListener('click', (e) => {
			if(!fBar.contains(e.target)) {
				fBar.querySelectorAll('[data-filter-wrap]').forEach(w => w.classList.remove('is-open'));
				const sortWrap = document.getElementById('CustomSortWrap');
				if(sortWrap) sortWrap.classList.remove('is-open');
				syncAriaExpanded();
			}

			const copyBtn = e.target.closest('.coupon-copy-btn');
			if(copyBtn) {
				e.preventDefault();
				const code = copyBtn.getAttribute('data-code');
				if(code) {
					navigator.clipboard.writeText(code).then(() => {
						copyBtn.classList.add('copied');
						setTimeout(() => copyBtn.classList.remove('copied'), 1500);
					});
				}
			}
		});
	}function snapFilters() {
		const s = {};
		for(const k of Object.keys(filters)) {
			const v = filters[k];
			s[k] = v instanceof Set ? new Set(v) : (v && typeof v === 'object' ? {...v} : v);
		}
		return s;
	}

	function openDrawer() {
		if(!drawer) return;
		drawerSnap = snapFilters();
		deferApply = true;
		renderPopovers();
		updateDynamicCounts();
		drawer.classList.add('is-open');
		drawer.setAttribute('aria-hidden', 'false');
		requestAnimationFrame(sbInitAll);
	}

	function closeDrawer(revert) {
		if(!drawer) return;
		if(revert && drawerSnap) {
			filters = drawerSnap;
			checkFiltersActive();
		}
		drawerSnap = null;
		deferApply = false;
		drawer.classList.remove('is-open');
		drawer.setAttribute('aria-hidden', 'true');
		renderPopovers();
		updateDynamicCounts();
	}

	function bindDrawer() {
		const trig = document.getElementById('FilterDrawerTrigger');
		if(!drawer || !trig) return;
		trig.addEventListener('click', openDrawer);
		drawer.addEventListener('click', (e) => {
			if(e.target.closest('[data-fd-apply]')) {
				closeDrawer(false);
				applyFilters();
				stavDoUrl();
				animGrid();
				return;
			}
			if(e.target.closest('[data-fd-close]')) {
				closeDrawer(true);
				return;
			}
			const head = e.target.closest('[data-fd-head]');
			if(head) {
				const g = head.closest('[data-filter-wrap]');
				const expanded = g.classList.toggle('is-expanded');
				head.setAttribute('aria-expanded', expanded ? 'true' : 'false');
				requestAnimationFrame(sbInitAll);
				setTimeout(sbInitAll, 350);
			}
		});
	}function ensureGridOrder() {
		if(!grid || (hasFilters && !onlyPreset())) return;
		const cards = grid.querySelectorAll('.custom-product-card');if(cards.length === 0 && filteredProds.length === 0) { rendered = 0; return; }
		let mismatch = cards.length === 0 || cards.length > filteredProds.length;
		if(!mismatch) {
			for(let i = 0; i < cards.length; i++) {
				const p = filteredProds[i];
				if(!p || cards[i].getAttribute('data-handle') !== p.han) { mismatch = true; break; }
			}
		}
		if(!mismatch) {
			rendered = cards.length;skViewList(filteredProds.slice(0, cards.length));
			if(rendered >= filteredProds.length) hideTrig(); else showTrig();
			return;
		}
		grid.innerHTML = '';
		const first = filteredProds.slice(0, BATCH_SZ);
		renderBatch(first, { pendingFadeIn: false });
		rendered = first.length;
		if(rendered >= filteredProds.length) hideTrig(); else showTrig();
		updateCountText();
	}const URL_SORT = 'razeni';

	function stavDoUrl() {
		const params = new URLSearchParams();
		const hotovo = new Set();
		for(const cfg of getConfigs()) {
			if(!cfg.id || hotovo.has(cfg.key)) continue;
			hotovo.add(cfg.key);
			const v = filters[cfg.key];
			if(!v) continue;
			if(v instanceof Set) {
				if(v.size > 0) params.set(cfg.id, [...v].map(String).sort().join(','));
			} else if(v.min != null && v.max != null) {
				params.set(cfg.id, v.min + '-' + v.max);
			}
		}
		if(currentSort && currentSort !== 'manual') params.set(URL_SORT, currentSort);

		const klice = [...params.keys()].sort();
		const serazene = new URLSearchParams();
		klice.forEach(k => serazene.set(k, params.get(k)));

		const qs = serazene.toString();
		const nova = location.pathname + (qs ? '?' + qs : '');
		if(nova === location.pathname + location.search) return;
		try { history.replaceState(null, '', nova); } catch(e) {}
	}function urlDoStavu() {
		const params = new URLSearchParams(location.search);
		if([...params.keys()].length === 0) return false;
		let nastaveno = false;

		for(const cfg of getConfigs()) {
			if(!cfg.id) continue;
			const raw = params.get(cfg.id);
			if(raw == null || raw === '') continue;
			if(cfg.type === 'slider') {
				const del = raw.split('-');
				const min = Number(del[0]), max = Number(del[1]);
				if(Number.isFinite(min) && Number.isFinite(max) && min <= max) {
					filters[cfg.key] = { min, max };
					nastaveno = true;
				}
			} else {
				const hodnoty = raw.split(',').map(s => s.trim()).filter(Boolean);
				if(hodnoty.length > 0) {
					filters[cfg.key] = new Set(hodnoty);
					nastaveno = true;
				}
			}
		}

		const sort = params.get(URL_SORT);
		if(sort && ['price-asc', 'price-desc', 'title-asc', 'manual'].includes(sort)) {
			currentSort = sort;
			nastaveno = true;
		}
		if(nastaveno) checkFiltersActive();
		return nastaveno;
	}

	const queueApply = debounce(() => {
		if(deferApply) {updateDynamicCounts();
			return;
		}
		applyFilters();
		stavDoUrl();
		animGrid();
	}, DEBOUNCE_MS);

	function waitImgs(card) {
		const imgs = card.querySelectorAll('img');
		if(imgs.length === 0) return Promise.resolve();
		const proms = [];
		imgs.forEach(img => {
			if(img.complete && img.naturalWidth > 0) return;
			proms.push(new Promise(res => {
				const done = () => { img.removeEventListener('load', done); img.removeEventListener('error', done); res(); };
				img.addEventListener('load', done);
				img.addEventListener('error', done);
			}));
		});
		return Promise.all(proms);
	}

	function fadeOutCards() {
		if(!grid) return Promise.resolve();
		const cards = grid.querySelectorAll('.custom-product-card');
		if(cards.length === 0) return Promise.resolve();
		cards.forEach(c => c.classList.add('is-fading-out'));
		return new Promise(res => setTimeout(res, FADE_OUT));
	}

	function staggerFadeIn(cards, token) {
		for(let i = 0; i < cards.length; i++) {
			const card = cards[i];
			const delay = i * FADE_STAGGER;
			setTimeout(() => {
				if(token !== animToken) return;
				waitImgs(card).then(() => {
					if(token !== animToken) return;
					card.classList.remove('is-fading-in-pending');
				});
			}, delay);
		}
	}

	async function animGrid() {
		animToken++;
		const token = animToken;

		await fadeOutCards();
		if(token !== animToken) return;

		resetGrid();
		if(token !== animToken) return;

		const cards = grid.querySelectorAll('.custom-product-card');
		staggerFadeIn(Array.from(cards), token);
	}

	function resetGrid() {
		if(!grid) return;
		grid.innerHTML = '';
		rendered = 0;

		if(filteredProds.length === 0) {
			grid.innerHTML = `<div class="filter-empty-state">${esc(T.emptyState || 'Žádné produkty.')}</div>`;
			hideTrig();
			return;
		}

		const first = filteredProds.slice(0, BATCH_SZ);
		renderBatch(first, { pendingFadeIn: true });
		rendered = first.length;

		if(rendered >= filteredProds.length) {
			hideTrig();
		} else {
			showTrig();
		}
		
		updateCountText();
	}

	function showTrig() {
		if(trigger) trigger.style.display = '';
	}

	function hideTrig() {
		if(trigger) trigger.style.display = 'none';
	}

	function renderReviewsHtml(p) {if(!p) return '';const score = Math.max(0, Math.min(5, Number(p.rs) || 0));
		const pocet = Number(p.rc) || 0;
		return `<span class="product-reviews-stars starRow" role="img" aria-label="${score} out of 5" style="--r:${score}"></span><span class="product-reviews-count">${pocet}×</span>`;
	}

	function paintReviews() {
		if(!grid) return;
		const slots = grid.querySelectorAll('[data-reviews-slot]');
		slots.forEach(slot => {
			const card = slot.closest('[data-handle]');
			if(!card) return;
			const handle = card.getAttribute('data-handle');
			const p = handleMap.get(handle);
			slot.innerHTML = renderReviewsHtml(p);
		});
	}

	function paintBadges() {
		if(!grid) return;
		const slots = grid.querySelectorAll('[data-badges-slot]');
		slots.forEach(slot => {
			const card = slot.closest('[data-handle]');
			if(!card) return;
			const handle = card.getAttribute('data-handle');
			const bgs = badges[handle];
			slot.innerHTML = (bgs && bgs.length > 0) ? renderBgsHtml(bgs) : '';
		});
	}

	function isBgActive(b, nowMs) {
		if(b.f) {
			const fromMs = Date.parse(b.f);
			if(Number.isFinite(fromMs) && nowMs < fromMs) return false;
		}
		if(b.u) {
			const toMs = Date.parse(b.u);
			if(Number.isFinite(toMs) && nowMs > toMs) return false;
		}
		return true;
	}

	function renderBgsHtml(bgs) {
		if(!Array.isArray(bgs) || bgs.length === 0) return '';
		const now = Date.now();
		const parts = [];
		for(const b of bgs) {
			if(!b || !b.t) continue;
			if(!isBgActive(b, now)) continue;
			const col = esc(b.c || '');
			const bg = esc(b.bg || '');
			const txt = esc(b.t);
			
			parts.push(`<div class="cp-badge" style="color: ${col}; background-color: ${bg};">${txt}</div>`);
		}
		return parts.join('');
	}

	function getCache(key) {
		try {
			const item = localStorage.getItem(key);
			if(item) return JSON.parse(item);
		} catch(e) { console.warn('Cannot read localStorage', e); }
		return null;
	}

	function setCache(key, data) {
		try {
			localStorage.setItem(key, JSON.stringify({ timestamp: Date.now(), data }));
		} catch(e) { console.warn('Cannot write localStorage', e); }
	}

	async function fetchRetry(url, { maxRet = MAX_RET, timeMs = TIMEOUT_MS } = {}) {
		let lastErr;
		for(let att = 0; att <= maxRet; att++) {
			const ctrl = new AbortController();
			const tId = setTimeout(() => ctrl.abort(), timeMs);
			try {
				const res = await fetch(url, { signal: ctrl.signal });
				clearTimeout(tId);
				if(!res.ok) throw new Error(`HTTP ${res.status}`);
				return res.json();
			} catch(err) {
				clearTimeout(tId);
				lastErr = err;
				if(att === maxRet) break;
				if(err.name === 'AbortError') continue;
				const delay = Math.min(1000 * Math.pow(2, att), 5000);
				await new Promise(r => setTimeout(r, delay));
			}
		}
		throw new Error(`Fetch failed for ${url}: ${lastErr && lastErr.message}`);
	}

	async function getProds() {
		const url = `${CONFIG.shopLanguageRoot}${API_PROD}`;
		const raw = await fetchRetry(url);
		return Array.isArray(raw) ? raw.flat() : [];
	}

	async function getExtras() {
		const url = `${CONFIG.shopLanguageRoot}${API_EXTRA}`;
		const raw = await fetchRetry(url);
		return {
			coupons: raw && Array.isArray(raw.coupons) ? raw.coupons : [],
			badges: raw && raw.badges && typeof raw.badges === 'object' ? raw.badges : {},
			colors: raw && raw.colors && typeof raw.colors === 'object' ? raw.colors : null,
			labels: raw && raw.labels && typeof raw.labels === 'object' ? raw.labels : null
		};
	}

	function updateProds(flat) {
		prodMap = new Map(flat.map(p => [p.pid, p]));
		handleMap = new Map(flat.map(p => [p.han, p]));
		const ids = collUnion || CONFIG.collectionProductIds || [];
		if(ids.length > 0) {
			colProds = ids.map((id, idx) => {
				const p = prodMap.get(id);
				if(p) p._idx = idx;
				return p;
			}).filter(Boolean);
		}
		applyFilters();
	}

	function updateExtras(ext) {
		coupons = ext.coupons || [];
		badges = ext.badges || {};
		if(ext.colors && typeof ext.colors === 'object') colorLegend = ext.colors;
		if(ext.labels && typeof ext.labels === 'object') valueLabels = ext.labels;
	}

	async function initProds() {
		const cached = getCache(CACHE_KEY);
		if(cached && (Date.now() - cached.timestamp < TTL_MS)) {
			return cached.data;
		}
		const data = await getProds();
		setCache(CACHE_KEY, data);
		return data;
	}

	async function syncBg() {
		const [pRes, eRes] = await Promise.allSettled([
			getProds(),
			getExtras()
		]);

		if(pRes.status === 'fulfilled') {
			setCache(CACHE_KEY, pRes.value);
			updateProds(pRes.value);
		} else {
			console.error('Background products sync failed:', pRes.reason);
		}

		if(eRes.status === 'fulfilled') {
			updateExtras(eRes.value);
			paintBadges();
			paintReviews();
		} else {
			console.error('Background extras sync failed:', eRes.reason);
		}
	}

	const observer = new IntersectionObserver((entries) => {
		if(entries[0].isIntersecting && isReady && !isPaused) loadMore();
	}, { rootMargin: '600px' });

	if(trigger) observer.observe(trigger);

	document.addEventListener('click', (e) => {
		const link = e.target.closest('a[href$="#vice"]');
		if(!link) return;
		
		const target = document.getElementById('vice');
		if(!target) return;

		e.preventDefault();
		
		if(history.pushState) history.pushState(null, null, '#vice');
		else location.hash = '#vice';

		isPaused = true;
		if(pauseTimer) clearTimeout(pauseTimer);

		const y = target.getBoundingClientRect().top + window.scrollY - 80;
		window.scrollTo({ top: y, behavior: 'smooth' });

		pauseTimer = setTimeout(() => {
			isPaused = false;
		}, 2500);
	});

	if(window.location.hash === '#vice') {
		isPaused = true;
		setTimeout(() => {
			const target = document.getElementById('vice');
			if(target) {
				const y = target.getBoundingClientRect().top + window.scrollY - 80;
				window.scrollTo({ top: y, behavior: 'smooth' });
			}
			pauseTimer = setTimeout(() => { isPaused = false; }, 2500);
		}, 300);
	}function syncSortUi() {
		const label = document.getElementById('CustomSortLabel');
		const opt = document.querySelector(`#CustomSortPopover .sort-option[data-val="${currentSort}"]`);
		if(opt) {
			document.querySelectorAll('#CustomSortPopover .sort-option').forEach(o => o.classList.remove('active'));
			opt.classList.add('active');
			if(label) label.textContent = opt.textContent.trim();
		}
	}

	async function init() {adoptCollectionFilter();
		paintBadges();
		bindBar();
		bindDrawer();const zAdresy = urlDoStavu();
		const predvyber = presetCurrentCollection();
		if(zAdresy || predvyber) { syncSortUi(); updateBarState(); }

		try {
			const [pData, eData] = await Promise.all([
				initProds(),
				getExtras().catch(err => {
					console.warn('Initial extras fetch failed, keeping Liquid data:', err);
					return { coupons: coupons, badges: badges };
				})
			]);

			updateProds(pData);if((zAdresy || hasFilters) && !onlyPreset()) animGrid();
			else ensureGridOrder();
			updateExtras(eData);
			paintBadges();
			paintReviews();
			renderPopovers();
			isReady = true;

			if(trigger && trigger.getBoundingClientRect().top < window.innerHeight + 600) {
				if(!isPaused) loadMore();
			} else if(rendered >= filteredProds.length) {
				hideTrig();
			}

			setInterval(syncBg, TTL_MS);

		} catch(err) {
			console.error('Critical init error:', err);
			if(trigger) trigger.innerHTML = T.loadingError || 'Chyba načítání.';
		}
	}window.addEventListener('resize', debounce(sbInitAll, 120));

	window.addEventListener('popstate', () => {
		if(!isReady) return;
		for(const k of Object.keys(filters)) delete filters[k];
		currentSort = 'manual';
		urlDoStavu();
		presetCurrentCollection();
		checkFiltersActive();
		syncSortUi();
		updateBarState();
		renderPopovers();
		applyFilters();
		animGrid();
	});

	function loadMore() {
		if(rendered >= filteredProds.length) return hideTrig();
		const batch = filteredProds.slice(rendered, rendered + BATCH_SZ);
		renderBatch(batch, { pendingFadeIn: false });
		rendered += batch.length;
		if(rendered >= filteredProds.length) hideTrig();
	}const CARD_WIDTHS = [100, 200, 300, 400, 500, 600, 800, 1000];const sameHost = (url) => url.replace(/^https?:\/\/cdn\.shopify\.com\/s\/files\/\d+(?:\/\d+)+\/(files|products)\//, '/cdn/shop/$1/');
	const getImgUrl = (url, w) => {
		if(!url) return '';
		const [base, q] = sameHost(url).split('?');
		const v = (q || '').split('&').find(p => p.indexOf('v=') === 0);
		return `${base}?format=webp${v ? '&' + v : ''}&width=${w}`;
	};
	const genSrcset = (url) => url ? CARD_WIDTHS.map(w => `${getImgUrl(url, w)} ${w}w`).join(', ') : '';

	function findCoupon(handle) {
		if(!coupons || coupons.length === 0) return null;
		return coupons.find(c => Array.isArray(c.handles) && c.handles.includes(handle)) || null;
	}

	function calcPrice(base, cpn) {
		if(!cpn) return base;
		if(cpn.type === 'Percentage') return base * (1 - (cpn.amount / 100));
		return base - cpn.amount;
	}

	function renderBatch(prods, opts) {
		const pending = !!(opts && opts.pendingFadeIn);
		const frag = document.createDocumentFragment();
		const imgSizes = "(max-width: 480px) calc(50vw - 16px), (max-width: 768px) calc(50vw - 28px), (max-width: 1200px) calc(33.33vw - 27px), (max-width: 1440px) calc(25vw - 25px), 320px";

		prods.forEach(p => {
			const img1 = (p.img && p.img.length > 0) ? p.img[0] : '';
			const img2 = (p.img && p.img.length > 1) ? p.img[1] : img1;

			const cv = cheapestVariant(p);
			const pPrice = cv ? cv.p : null;
			const cPrice = (cv && typeof cv.o === 'number' && Number.isFinite(cv.o)) ? cv.o : null;

			const cpn = findCoupon(p.han);
			const fPrice = calcPrice(pPrice, cpn);

			const url = `${CONFIG.shopLanguageRoot}products/${p.han}`;
			const card = document.createElement('div');
			card.className = 'custom-product-card';
			if(pending) card.classList.add('is-fading-in-pending');
			card.setAttribute('data-handle', p.han);

			const bgsHtml = renderBgsHtml(badges[p.han]);

			let priceHtml = '';let b2bBlok = null;
			if(B2B) {
				b2bBlok = b2bPriceHtml(p.pid);
			} else {
				if(pPrice !== null) {
					if(cPrice !== null && cPrice > pPrice) {
						priceHtml += `<span class="price-compare">${esc(fmtMoney(cPrice))}</span>`;
					}
					priceHtml += `<span>${esc(fmtMoney(pPrice))}</span>`;
				}
			}

			const title = esc(p.tit);
			const hasHoverClass = img2 && img1 !== img2 ? 'has-hover' : '';
			const imgHtml = img1
				? `<img class="image-primary" src="${getImgUrl(img1, 400)}" srcset="${genSrcset(img1)}" sizes="${imgSizes}" alt="${title}" loading="lazy">
					${img2 && img1 !== img2 ? `<img class="image-secondary" src="${getImgUrl(img2, 400)}" srcset="${genSrcset(img2)}" sizes="${imgSizes}" alt="${title}" loading="lazy">` : ''}`
				: `<div style="display:flex; height:100%; align-items:center; justify-content:center; color:inherit; opacity: 0.6; position:absolute; width:100%;">${esc(T.noImage || 'Bez fota')}</div>`;

			let sizeKey = null;
			let sizesHtml = '';
			if (p.var && p.var.length > 0) {
				sizeKey = Object.keys(p.var[0]).find(k => typeof k === 'string' && (k.toLowerCase() === 'velikost' || k.toLowerCase() === 'size'));
			}

			if (sizeKey) {
				const revVars = [...p.var].reverse();
				const btnHtml = revVars.map(v => {
					const sName = v[sizeKey];
					const isDisabled = (v.q !== undefined && v.q <= 0) ? 'is-disabled' : '';
					const vId = v.id || v.i || '';
					const link = vId ? `${url}?variant=${vId}` : url;
					return `<a href="${link}" class="cp-size-btn ${isDisabled}">${esc(sName)}</a>`;
				}).join('');

				sizesHtml = `
				<div class="cp-sizes-overlay">
					<div class="cp-sizes-list">
						${btnHtml}
					</div>
				</div>`;
			}

			let cpnHtml = '';if(cpn && !B2B) {
				const cpnTxtHtml = cpn.text ? `<div class="coupon-banner-sub">${esc(cpn.text)}</div>` : '';
				cpnHtml = `
					<div class="coupon-banner xs">
						<div class="coupon-banner-main">
							<img src="https://cdn.shopify.com/s/files/1/0826/7785/8646/files/discount.webp?v=1780487966" class="coupon-icon" alt="" loading="lazy">
							<strong class="coupon-price sm">${esc(fmtMoney(fPrice))}</strong>
							<span class="coupon-text-with xs">${esc(T.withCoupon || '')}</span>
							<strong class="coupon-code sm">${esc(cpn.code)}</strong>
							<button type="button" class="coupon-copy-btn" data-code="${esc(cpn.code)}" aria-label="${esc(T.copyCode || 'Kopírovat')}">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
								<span class="coupon-copy-tooltip">${esc(T.copied || 'Zkopírováno')}</span>
							</button>
						</div>
						${cpnTxtHtml}
					</div>
				`;
			}

			const reviewsHtml = renderReviewsHtml(p);

			card.innerHTML = `
				<div class="image-wrapper ${hasHoverClass}">
					<div class="badges-container" data-badges-slot>${bgsHtml}</div>
					<a href="${url}" class="card-img-link" aria-label="${title}">
						${imgHtml}
					</a>
					${sizesHtml}
				</div>
				<a href="${url}" class="product-info-link">
					<div class="product-reviews" data-reviews-slot>${reviewsHtml}</div>
					<h3 class="product-title-wrap"><span class="title-underline">${title}</span></h3>
					${b2bBlok !== null ? b2bBlok : `<div class="product-price">${priceHtml}</div>`}
				</a>
				${cpnHtml}
			`;

			frag.appendChild(card);
		});

		grid.appendChild(frag);if(window.skTrack && window.skTrack.viewItemList) skViewList(prods);
	}var skPoslano = new Set();
	function skVariantTitle(v) {
		var vyhr = {i: 1, q: 1, p: 1, o: 1, _vis: 1};
		return Object.keys(v || {}).filter(function(k) { return !vyhr[k]; }).map(function(k) { return v[k]; }).join(" / ");
	}
	function skViewList(prods) {
		var L = CONFIG.list || {};
		if(!L.item_list_id) return;
		var items = [];
		prods.forEach(function(p) {
			if(!p || skPoslano.has(p.pid)) return;
			skPoslano.add(p.pid);
			var v = (p.var && p.var[0]) || {};
			items.push({product_id: p.pid, variant_id: v.i, vendor: p.ven, total_discount: 0,
				variant_title: skVariantTitle(v), product_title: p.tit,
				final_price: Math.round((v.p || 0) * 100), product_type: p.typ,
				item_list_id: L.item_list_id, item_list_name: L.item_list_name, quantity: 1});
		});
		if(items.length) window.skTrack.viewItemList({items: items, item_list_id: L.item_list_id, item_list_name: L.item_list_name});
	}

	if(CONFIG.collectionProductIds && CONFIG.collectionProductIds.length > 0) {
		init();
	} else {hideTrig();
		if(fBar) fBar.style.display = 'none';
		if(drawer) drawer.style.display = 'none';
	}
})();